import React from "react";
import { HomeFooterWrapper } from "./HomeFooterStyle";
import LogoTextSvg from "assets/icons/color-logo-text.svg";
import InstagramSvg from "assets/icons/homeInstagram.svg";
import KakaoTalkSvg from "assets/icons/homeKakaoTalk.svg";
import { Link } from "react-router-dom";

const HomeFooter = () => {
  return (
    <HomeFooterWrapper>
      <img src={LogoTextSvg} alt="logo" />
      <div className="explain-text">
        <a
          href="https://floway.notion.site/floway-e05843c9734349adb72f31c5eeb5f102"
          target="_blank"
          rel="noreferrer"
        >
          서비스 소개
        </a>{" "}
        ㅣ 서비스 이용약관 ㅣ{" "}
        <Link to="/privacy-policy">개인정보 처리방침</Link> ㅣ{" "}
        <Link to="/info-provision">정보제공안내</Link>
      </div>
      <p className="require-text">
        문의 : 플로웨이 카카오톡 채널 (10:00 ~ 17:00)
      </p>
      <div className="social-section">
        <a
          href="https://www.instagram.com/official_floway/"
          target="_blank"
          rel="noreferrer"
          style={{ display: "flex", color: "#4A5056", marginRight: "20px" }}
        >
          <img
            src={InstagramSvg}
            alt="Instgram"
            style={{ marginRight: "6px" }}
          />
          <p>플로웨이 인스타그램</p>
        </a>
        <a
          href="http://pf.kakao.com/_xohbhxj"
          target="_blank"
          rel="noreferrer"
          style={{ display: "flex", color: "#4A5056" }}
        >
          <img
            src={KakaoTalkSvg}
            alt="KakaoTalk"
            style={{ marginRight: "6px" }}
          />
          <p>플로웨이 카카오톡 채널</p>
        </a>
      </div>
    </HomeFooterWrapper>
  );
};

export default HomeFooter;
